/**
 * AuthReasonsList Component - List of Reasons for Auth Issues
 *
 * Displays a list of possible reasons for verification failures or other auth issues.
 * Used in error/failure screens to help users understand what went wrong.
 *
 * USAGE:
 * <AuthReasonsList>
 *   <AuthReasonsList.Reason icon={<SpriteIcon name="clock" size={16} />}>
 *     The link has expired (links are valid for 20 minutes)
 *   </AuthReasonsList.Reason>
 *   <AuthReasonsList.Reason icon={<SpriteIcon name="link" size={16} />}>
 *     The link has already been used once
 *   </AuthReasonsList.Reason>
 * </AuthReasonsList>
 */

import React from 'react';
import '../../theme-components/52-verification-failed.css';

export interface AuthReasonsListProps {
  children: React.ReactNode;
  className?: string;
}

export interface AuthReasonProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const AuthReasonsList: React.FC<AuthReasonsListProps> & {
  Reason: React.FC<AuthReasonProps>;
} = ({ children, className = '' }) => {
  return (
    <div className={`verification-failed-card__reasons ${className}`}>
      {children}
    </div>
  );
};

const Reason: React.FC<AuthReasonProps> = ({ icon, children, className = '' }) => {
  return (
    <div className={`verification-failed-card__reason ${className}`}>
      <div className="verification-failed-card__reason-icon">
        {icon}
      </div>
      <div className="verification-failed-card__reason-text">
        {children}
      </div>
    </div>
  );
};

AuthReasonsList.Reason = Reason;

export default AuthReasonsList;
